module.exports = __webpack_public_path__ + "bac2956c016043e425b5569d36edc1c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar_Eco8_grau_display@2x.png
// module id = 258
// module chunks = 0